<template>
  <div id="ag-grid-demo">
    <vx-card>
      <data-table
        :column-defs="columnDefs"
        :default-col-def="defaultColDef"
        :row-data="userList"
        :grid-options="gridOptions"
        pagination
      >
        <template #actions>
          <vs-button
            @click="onClickRegister"
          >
            ユーザー追加
          </vs-button>
        </template>
      </data-table>
    </vx-card>
    <form-modal
      v-model="showForm"
      title="ユーザー追加"
      submit-button-text="招待メールを送る"
      @click:submit="onClickSubmit"
    >
      <template #content>
        <ValidationForm ref="userInviteObserver">
          <email-field
            v-model="email"
            class="mb-8"
            rules="required|email"
            full-width
            @keydown.enter="onKeydownEnter"
          />
        </ValidationForm>
      </template>
    </form-modal>
    <confirm-modal
      v-model="showConfirmModal"
      @click:confirm="onClickConfirm"
      @click:cancel="showConfirmModal = false"
    >
      <template #content>
        <p class="p-4 whitespace-pre-wrap">
          本当に削除しますか？
        </p>
      </template>
    </confirm-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataTable from '@/components/table/DataTable'
import FormModal from '@/components/modals/FormModal'
import EmailField from '@/components/fields/EmailField'
import DataTableCellSwitch from '@/components/table/DataTableCellSwitch'
import DataTableCellTrash from '@/components/table/DataTableCellTrash'
import ConfirmModal from '@/components/modals/ConfirmModal'

export default {
  name: 'UserManagement',
  components: {
    ConfirmModal,
    FormModal,
    DataTable,
    EmailField
  },
  data () {
    return {
      pageSize: 20,
      defaultColDef: {
        sortable: false,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'No.',
          field: 'no'
        },
        {
          headerName: 'メールアドレス',
          field: 'email'
        }
      ],
      gridOptions: {},
      id: null,
      email: null,
      showForm: false,
      showConfirmModal: false,
      confirmMessage: null
    }
  },
  computed: {
    ...mapState('user', ['users']),
    ...mapState('account', ['activeAccount']),
    ...mapState('auth', ['activeUserId', 'activeUser']),
    userList () {
      const unAdminUser = this.users.filter(u => u.is_admin === 0)
      return unAdminUser.map((object, index) => {
        return {...object, no: index + 1}
      })
    }

  },
  watch: {
    showForm (value) {
      if (!value) {
        this.$nextTick(function () {
          this.resetUser()
          requestAnimationFrame(() => {
            this.$refs.userInviteObserver.resetForm()
          })
        })
      }
    },
    showConfirmModal (value) {
      if (!value) {
        this.$nextTick(function () {
          window.setTimeout(() => {
            this.resetUser()
          }, 300)
        })
      }
    }
  },
  beforeMount () {
    this.gridOptions = {
      autoSizeStrategy: {
        type: 'fitGridWidth'
      },
      components: {
        dataTableCellSwitch: DataTableCellSwitch,
        dataTableCellTrash: DataTableCellTrash
      }
    }
  },
  async mounted () {
    await this.listUsers()
  },
  methods: {
    ...mapActions('user', ['listUsers', 'deleteUser']),
    ...mapActions('userAccounts', ['addUserEmail']),
    onClickRegister () {
      this.showForm = true
    },
    async checkBoxAction ({ index, value }) {
      await this.updateKeyword({
        ...this.users[index],
        enabled: value
      })
    },
    trashAction ({ index }) {
      const targetUser = this.users[index]
      this.id = targetUser.id
      this.email = targetUser.email
      this.showConfirmModal = true
    },
    resetUser () {
      this.id = null
      this.email = null
    },
    async onClickConfirm () {
      try {
        await this.deleteUser({
          id: this.id
        })
        this.showConfirmModal = false
      } catch (e) {
        console.log(e)
      }
    },
    async onClickSubmit () {
      const isValid = await this.$refs.userInviteObserver.validate()
      if (!isValid.valid) return
      if (this.users.some(user => user.email === this.email)) return
      try {
        await this.addUserEmail({
          email: this.email,
          userId: this.activeUserId,
          accountId: this.activeAccount.id
        })
        this.showForm = false
      } catch (e) {
        console.log(e)
      }
    },
    onKeydownEnter (event) {
      event.stopPropagation()
      event.preventDefault()
      // 日本語入力中のEnterキー操作は無効にする
      if (event.keyCode !== 13) return
      this.onClickSubmit()
    }
  }
}

</script>

<style>
</style>
